import { useState } from "react";
import { signIn } from "./lib/api";
import { isConfigured } from "./lib/supabase";

/* The sign-in screen that stands in front of the Studio.
   Only an account listed in the `admins` table can do anything once inside —
   see supabase/schema.sql. */
export default function AdminLogin({ onDone, notAdmin, onSignOut }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const { error } = await signIn(email.trim(), password);
    setBusy(false);
    if (error) setErr(error.message || "Those details didn't work.");
    else if (onDone) onDone();
  };

  if (!isConfigured) {
    return (
      <div className="kg-page kg-wrap kg-section" style={{ maxWidth: 480 }}>
        <div className="kg-caps">Artist studio</div>
        <h2 className="kg-display">Local preview</h2>
        <p style={{ color: "var(--ink2)" }}>
          This copy of the site isn't connected to the database yet, so there is nothing to log in to —
          the Studio is open and everything you change stays in this browser only.
        </p>
        <button className="kg-btn kg-btn-primary" onClick={() => onDone && onDone()}>Open the studio anyway</button>
      </div>
    );
  }

  if (notAdmin) {
    return (
      <div className="kg-page kg-wrap kg-section" style={{ maxWidth: 480 }}>
        <div className="kg-caps">Artist studio</div>
        <h2 className="kg-display">Not your studio</h2>
        <p style={{ color: "var(--ink2)" }}>
          You're signed in, but this account isn't the artist's account, so it can't change the gallery.
        </p>
        <button className="kg-btn kg-btn-ghost" onClick={onSignOut}>Sign out</button>
      </div>
    );
  }

  return (
    <div className="kg-page kg-wrap kg-section" style={{ maxWidth: 420 }}>
      <div className="kg-caps">Artist studio</div>
      <h2 className="kg-display">Sign in</h2>
      <p style={{ color: "var(--ink2)", fontSize: 14 }}>
        This area is for Karima only. Visitors never see it and can't change anything in the gallery.
      </p>
      <form onSubmit={submit} style={{ marginTop: 18 }}>
        <div className="kg-field">
          <label htmlFor="a-email">Email</label>
          <input id="a-email" className="kg-input" type="email" autoComplete="username"
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="kg-field">
          <label htmlFor="a-pass">Password</label>
          <input id="a-pass" className="kg-input" type="password" autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {err && <p role="alert" style={{ color: "var(--red)", fontSize: 14, marginTop: 0 }}>{err}</p>}
        <button className="kg-btn kg-btn-primary" type="submit" disabled={busy || !email.trim() || !password}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
